import React, { Component } from 'react';
import BackgroundImage from '../assets/images/sky-34536_1280.png'
import M from 'materialize-css'

class Home extends Component {
  componentDidMount() {
    let elements = document.querySelectorAll('.parallax');
    M.Parallax.init(elements);
  }
  
  render() {
    console.log(this.props)
    return (
        <div>
              <div className="parallax-container valign-wrapper" style={{height: "800px"}}>
                <div className="container">
                  <div className="row">
                    <div className="col s12">
                      <h1 className="white-text">Willkommen auf Relatively Unique</h1>
                      <p className="flow-text white-text">Ihr Partner für innovative AI Applikationen und Data Analytics</p>
                    </div>
                  </div>
                </div>
                <div className="parallax">
                  <img src={BackgroundImage} alt="" />
                </div>
              </div>
        </div>
    )
  }
}

export default Home;
